import './styles.scss';
import { PPDWidgetCompareChart } from "pages/profile-dashboard/components/PPDWidget/components/PPDWidgetCompare/components/PPDWidgetCompareChart";
import { PPDWidgetBaseProperties } from '../../../PPDWidgetBaseProperties';
import { IUserDashboardGroup, IUserDashboardLabels, IUserDashboardWidgetItemModel } from 'shared/models';
import { useDashboardDict } from '../../../../../../context/useDashboardDict';
import { PPDModal } from '../../../../../PPDModal';
import { PPDWidgetGroupSelect } from 'pages/profile-dashboard/components/PPDWidget/components/PPDWidgetGroupSelect';
import { PPDWidgetPropertiesBadge } from '../../components/PPDWidgetPropertiesBadge';
import { useMedia, useStore } from 'shared/hooks';
import { observer } from 'mobx-react';
import { PPWDWidgetNotice } from 'pages/profile-dashboard/components/PPDWidget/components/PPDWidgetNotice';
import { EntityId } from 'shared/models/UserDashboardModel.ts';

type StoreId = IUserDashboardWidgetItemModel['store_id'];
type PPDWidgetStoreStatsModalProps = {
    item: IUserDashboardWidgetItemModel
    onClose: () => void
    labels?: IUserDashboardLabels;
    groupId: EntityId | null;
    groups?: IUserDashboardGroup[];
    onChangeGroup: (groupId: string | number) => void;
    isMonoStore?: boolean
}

export const PPDWidgetCompareModal = observer(({
    item, onClose, labels, groupId, groups = [], onChangeGroup, isMonoStore = false
}: PPDWidgetStoreStatsModalProps) => {
    const { stores } = useDashboardDict();

    const { isMobileOrTablet } = useMedia()

    const store = useStore(() => ({
        isOpenNotice: false
    }))


    const getStoreName = (storeId: StoreId) => {
        if (storeId === null) return 'Бутик';

        // Ищем магазин по ID, учитывая возможные типы данных
        const store = stores?.find(s => {
            // Сравниваем как числа, так и строки
            return s.id === storeId || s.id === Number(storeId) || s.id === String(storeId);
        });

        return store?.name ?? 'Бутик';
    };

    const storeName = getStoreName(item.store_id);
    const progress = Number(item.value?.amount ?? 0);
    const statistic = item.statistic || [];

    const handleToggle = () => {
        if (!isMonoStore) return;
        store.set("isOpenNotice", true);
    };

    const handleCloseNotice = () => {
        store.set("isOpenNotice", false)
    }

    if (!item) {
        return null;
    }

    return (
        <>
            <PPDModal isOpened={!!item} onClose={onClose}>
                <div className="ppd-widget-stats-store-modal">
                    <div className="ppd-widget-stats-store-modal__header">
                        {storeName && <div className="ppd-widget-stores-modal__title">{storeName}</div>}

                        {groups.length > 0 && groupId && (
                            <PPDWidgetGroupSelect
                                items={groups} // Доступные группы для выбора
                                value={groupId} // Текущая выбранная группа
                                onChange={onChangeGroup} // Обработчик смены группы
                                activeToggle={!isMonoStore}
                                onClickToggle={handleToggle}
                            />
                        )}
                    </div>

                    <div className="ppd-widget-stats-store-modal__content">
                        <div className="ppd-widget-stats-store-modal__wrapper">
                            <PPDWidgetCompareChart progress={progress} size={isMobileOrTablet ? 140 : 182}/>
                        </div>

                        <PPDWidgetBaseProperties
                            item={item}
                            labels={labels}
                            className="ppd-widget-stats-store-modal__properties"
                        >
                            {(statistic.length > 0) && (
                                <PPDWidgetPropertiesBadge
                                    statistic={statistic}
                                    label_full={labels?.statistic_full}
                                    label_short={labels?.statistic_short}
                                    zIndexTooltip={99999}
                                />
                            )}
                        </PPDWidgetBaseProperties>
                    </div>
                </div>
            </PPDModal>
            <PPWDWidgetNotice
                text="Невозможно изменить группу"
                isOpen={store.isOpenNotice}
                onClose={handleCloseNotice}
                autoHideDuration={5000}
            />
        </>
    );
});

